import { ConversationLanguageCode } from 'lib-shared-languages';
import { useContext, useEffect, useState } from 'react';

import { ConversationContext } from 'components/conversation';
import {
  UseTranslateTextDropdownButtonSelectionList,
  useTranslateTextDropdownSelectionList,
} from 'components/useTranslateTextDropdownSelectionList';

type UseTranslatePlainTextConversationMessageProps = Pick<
  UseTranslateTextDropdownButtonSelectionList,
  'text' | 'originalLanguageCode' | 'isDisabled' | 'contentType'
>;

type UseTranslatePlainTextConversationMessageResult = ReturnType<
  typeof useTranslateTextDropdownSelectionList
>;

/** Represents a hook for handling plain text conversation message translation. */
export function useTranslatePlainTextConversationMessage(
  props: UseTranslatePlainTextConversationMessageProps,
): UseTranslatePlainTextConversationMessageResult {
  const { text, isDisabled, originalLanguageCode, contentType } = props;
  const { translationLanguageCode, conversation } =
    useContext(ConversationContext);
  const [selectedLanguageCode, setSelectedLanguageCode] =
    useState<ConversationLanguageCode>();

  const translateTextDropdownButtonResult =
    useTranslateTextDropdownSelectionList({
      languageCode: selectedLanguageCode,
      originalLanguageCode,
      text,
      isDisabled,
      csid: conversation?.id?.toString(),
      contentType,
    });

  useEffect(() => {
    setSelectedLanguageCode(translationLanguageCode);
  }, [translationLanguageCode]);

  return translateTextDropdownButtonResult;
}
